/* eslint-disable import/prefer-default-export */

import { css } from '@emotion/core';
export var stickySidebox = {
  name: "8kjoqe",
  styles: "position:sticky;top:0;"
};